import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startSpinner, finishSpinner } from "../ui/spinner";
import { handleErrorApi } from "../../helpers/randoms";
import { startAlerta } from "../ui/alertas";
import moment from "moment";
import axios from "axios";


export const armarParametrosMedicacion310 = (medicamentoFiltro,
  activosPorFecha,
  fechaDesde,
  fechaHasta) => {

    let p1 = activosPorFecha ? `activosPorFecha=${activosPorFecha}` : ``;
    let p2 = medicamentoFiltro ? `&medicamentoFiltro=${medicamentoFiltro}` : ``;
    //let p3 = fechaDesde ? `&fechaDesde=${fechaDesde.toISOString()}` : ``;
    let p3 = fechaDesde && moment(fechaDesde).isValid() ? `&fechaDesde=${fechaDesde}` : ``;
    let p4 = fechaHasta && moment(fechaHasta).isValid() ? `&fechaHasta=${fechaHasta}` : ``;
    
    return `${p1}${p2}${p3}${p4}`;
};

export const setActivosPorFecha = (activoPorFecha) => async (dispatch) => {
  dispatch({
    type: types.empadronamientoMedicamentos310SetActivosPorFecha,
    payload: activoPorFecha,
  })
}

export const getMedicamentos310 =
  (medicamentoFiltro = null, activosPorFecha, fechaDesde, fechaHasta) =>
    async (dispatch) => {
      dispatch({ type: types.empadronamientoMedicamentos310TraerStart });

      try {
        const response = await fetchConToken(`Medicamentos310/TraerMedicamentos?${armarParametrosMedicacion310(
          medicamentoFiltro,
          activosPorFecha,
          fechaDesde,
          fechaHasta
        )}`);
        let body = await response.json();

        if (response.ok) {
          dispatch({
            type: types.empadronamientoMedicamentos310TraerSuccess,
            payload: body,
          });
        } else {
          throw body;
        }
      } catch (error) {
        handleErrorApi(
          dispatch,
          error,
          "Error al cargar los medicamentos.",
          "Ha ocurrido un error. Intente nuevamente"
        );
        dispatch({ type: types.empadronamientoMedicamentos310TraerError });
      }
    };

export const guardarMaterial = (codigoNum, datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    let response;
    if (codigoNum > 0) {
      response = await fetchConToken(`NomencladorProtesis/${codigoNum}`, datos, "PUT");
    } else {
      response = await fetchConToken(`NomencladorProtesis`, datos, "POST");
    }

    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          "Material guardado correctamente",
          "success",
          "Comando Exitoso"
        )
      );
      dispatch(finishSpinner());
      dispatch(getMedicamentos310(null));
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al guardar un nuevo material.",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const eliminarMaterial = (codigoNum) => async (dispatch) => {
  try {
    const response = await fetchConToken(`NomencladorProtesis/${codigoNum}`, '', 'DELETE');
    const body = await response.json();
    if (response.ok) {
      dispatch(startAlerta("Material eliminado correctamente", 'success', 'Comando Exitoso'));
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(dispatch, error, "Error al eliminar el material.", "Ha ocurrido un error. Intente nuevamente")
  }
};


// PLANTILLA
const baseUrl = process.env.REACT_APP_API_URL;

export const SubirArchivoExcel = (file) => async (dispatch, getState) => {
  dispatch(startSpinner());
  
  const url = `${baseUrl}/Medicamentos310/CargarExcel`;
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || "";
  let httpHeaders;

  if (token) {
    httpHeaders = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
  }
  const formData = new FormData();
  formData.append("formFile", file);
  try {
    const result = await fetch(url, {
      method: "POST",
      body: formData,
      headers: httpHeaders,
    });
    const body = await result.json();
    if (result.ok) {
      dispatch(finishSpinner());
      dispatch(startAlerta(`Archivo subido correctamente`, 'success', 'Comando Exitoso'));
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al subir el archivo",
      "Ha ocurrido un error. Intente nuevamente",
      false
    );
  }
};

export const DescargarPlantillaExcel = () => async (dispatch, getState) => {
  const url = `${process.env.REACT_APP_URL}/public-templates/Planilla-Carga-Medicamentos310.xls`;
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || "";
  let httpHeaders;
  if (token) {
    httpHeaders = {
      Authorization: `Bearer ${token}`,
    };
  }
  try {
    axios({
      url: url,
      method: "GET",
      responseType: "blob",
      headers: httpHeaders,
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Planilla-Carga-Medicamentos310.xls`);
      document.body.appendChild(link);
      link.click();
    });
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      "Error al descargar el archivo",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

